import React from 'react'
import Helmet from 'react-helmet'
import Faq from 'components/Faq'
import Layout from 'components/Layout'
import Container from 'components/Container'
import { Title } from 'components/Page'
import InfoIcon from 'components/icons/Info'
import IconContainer from 'components/icons/Container'
import faqs from 'data/faqs'

const Faqs = () => (
  <Layout>
    <Helmet
      title="Dental FAQs | Oregon City Smiles"
      meta={[
        {
          name: 'description',
          content:
            'Find answers to common dental questions at Oregon City Smiles. Learn about insurance, first visits, dental procedures, and oral health tips from our Oregon City dentists.'
        },
        {
          property: 'og:title',
          content: 'Dental FAQs | Oregon City Smiles'
        },
        {
          property: 'og:description',
          content:
            'Find answers to common dental questions at Oregon City Smiles. Learn about insurance, first visits, and dental procedures.'
        }
      ]}
    />
    <Container>
      <Title>
        <IconContainer color="primary">
          <InfoIcon color="white" size="2rem" />
        </IconContainer>
        FAQs
      </Title>
      <div className="mt-8 mx-auto mb-16">
        {faqs.map(({ q, a }, idx) => (
          <Faq key={idx} question={q} answer={a} />
        ))}
      </div>
    </Container>
  </Layout>
)

export default Faqs
